import type {SubsurfaceScatteringNode} from "#material/cycles/types"
import type {SubsurfaceFalloff} from "#material/nodes/shader/subsurface-scattering/types"

export const cyclesFalloff = (falloff?: SubsurfaceFalloff): SubsurfaceScatteringNode["parameters"]["method"] => {
    if (!falloff) {
        return undefined
    }
    switch (falloff) {
        case "BURLEY":
            return "burley"
        case "RANDOM_WALK":
            return "random_walk"
        case "RANDOM_WALK_SKIN":
            return "random_walk_skin"
    }
}
